var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-main-page",style:({overflowY: _vm.scroll})},[_c('mobile-header-bar',{on:{"is-scroll":_vm.isScroll}}),_c('sub-banner'),_c('router-view'),_c('mobile-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }